import { SidebarSectionType } from 'data/types';

export const STEP_ACCURACY_WEIGHTS: Record<string, number> = {
  floors_and_levels: 10,
  structure_details: 15,
  base_layout: 40,
  space_details: 30,
  sizing_tuning: 5
};

function isSectionComplete(section: SidebarSectionType): boolean {
  const steps = section.steps ?? [];
  if (steps.length === 0) return false;
  return steps.every((step) => step.status === 'complete');
}

export function computeAccuracyFromSections(
  sections: SidebarSectionType[]
): number {
  return Object.entries(STEP_ACCURACY_WEIGHTS).reduce(
    (acc, [stepCode, weight]) => {
      const matching = sections.filter(
        (section) => section.step_code === stepCode
      );
      if (matching.length === 0) return acc;
      const allComplete = matching.every(isSectionComplete);
      const allContribute = matching.every(
        (section) => section.accuracyContributionEarned !== false
      );
      return acc + (allComplete && allContribute ? weight : 0);
    },
    0
  );
}
